import { type ReactNode, createContext, useCallback, useState } from "react";

export const UploadProgressContext = createContext<{
	getProgress: (uploadId: string) => number | undefined;
	setProgress: (uploadId: string, progress?: number | undefined) => void;
	toasts: Record<string, number>;
}>({ getProgress: () => undefined, setProgress: () => {}, toasts: {} });

export function UploadProgressProvider({ children }: { children: ReactNode }) {
	const [toasts, setToasts] = useState<Record<string, number>>({});

	const setProgress = (uploadId: string, progress: number | undefined) => {
		if (progress !== 0 && !progress) {
			setToasts((prev) => {
				const { [uploadId]: _, ...rest } = prev;

				return rest;
			});
		} else {
			setToasts((prev) => ({ ...prev, [uploadId]: progress }));
		}
	};

	const getProgress = useCallback(
		(uploadId: string) => {
			return toasts[uploadId];
		},
		[toasts],
	);

	return (
		<UploadProgressContext.Provider
			value={{ getProgress, setProgress, toasts }}
		>
			{children}
		</UploadProgressContext.Provider>
	);
}
